import { Injectable } from '@angular/core';
import { DataService } from '../../../../Autofacets-Core/src/app/services/data.service';
import { GenericResponse } from '../business-entities/generic-response';
import { RentalCar } from '../business-entities/rental-car.interface';
import { Urls } from './../../../../Autofacets-Core/src/app/utils/urls';

@Injectable({
    providedIn: 'root'
})

export class RentalCarDataService {
    constructor(private dataProvider: DataService) {
    }

    GetRentalCarList(dealerId: string, status: number): Promise<any> {
        return this.dataProvider.Get<GenericResponse<any>>(Urls.GetRentalCarList, dealerId, status).toPromise();
    }

    AddRentalCar(rentalCar: RentalCar): Promise<any> {
        return this.dataProvider.Post<GenericResponse<any>>(Urls.AddRentalCar, rentalCar).toPromise();
    }


    GetFuelTypes(): Promise<any> {
        return this.dataProvider.Get<GenericResponse<any>>(Urls.GetFuelTypes).toPromise();
    }

    GetRentalCarById(Id: number): Promise<any> {
        return this.dataProvider.Get<GenericResponse<any>>(Urls.GetRentalCarById, Id).toPromise();
    }

    EditRentalCar(editRentalCar: RentalCar): Promise<any> {
        return this.dataProvider.Put<GenericResponse<any>>(Urls.EditRentalCar, editRentalCar).toPromise();
    }

    DeleteRentalCar(rentalCarId: number): Promise<any> {
        return this.dataProvider.Delete<GenericResponse<any>>(Urls.DeleteRentalCar, rentalCarId).toPromise();
    }
    GetAllBrand(): Promise<any> {
        return this.dataProvider.Get<GenericResponse<any>>(Urls.GetBrands).toPromise();
    }

    GetAllVehicleStatus(): Promise<any> {
        return this.dataProvider.Get<GenericResponse<any>>(Urls.GetAllVehicleStatus).toPromise();
    }
}